module.exports = __webpack_public_path__ + "static/media/сушарка-для-фруктів-інпрофіт.5f8d3a23.jpg";